export const fetchAddressesListFromApiPP = (searchQuery, apiKey) => {
    if (!searchQuery) return Promise.resolve([]);

    const url = `https://api.poczta-polska.pl/maps/v1/search/address/json?api-version=1.0&subscription-key=${apiKey}&countrySet=PL&language=pl-PL&typeahead=true&query=${encodeURIComponent(searchQuery)}`;

    const headers = new Headers();
    headers.append('Accept', 'application/json');

    return fetch(url, { method: 'GET', headers: headers })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(data => {
            return data.results.map(item => {
                let name = [
                    item.address.streetName,
                    item.address.streetNumber,
                    item.address.postalCode,
                    item.address.municipalitySubdivision,
                    item.address.municipality,
                    item.address.countrySubdivisionName,
                    item.address.country
                ].filter(Boolean).join(' ');

                return {
                    'latitude': item.position.lat,
                    'longitude': item.position.lon,
                    'label': name,
                    'value': name
                };
            });
        })
        .catch(error => {
            console.error('API Error:', error);
            throw error;
        });
};

/**
 * Pobiera listę powiatów dla danego województwa
 */
export const fetchDistricts = (province, lang, baseUrl) => {
    const url = `${baseUrl}/wp-content/plugins/pp-poiloader/province.php`;
    const data = new FormData();
    data.append('province', province);
    data.append('lang', lang);

    return fetch(url, {
        method: 'POST',
        body: data
    })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        });
};

/**
 * Resetuje element select do stanu domyślnego
 */
export const resetSelectElement = (element, defaultText = 'powiat') => {
    if (!element) return;
    element.innerHTML = '';
    const myOption = document.createElement("option");
    myOption.text = defaultText;
    myOption.value = '0';
    element.appendChild(myOption);
};

/**
 * Pobiera kod języka na podstawie ścieżki URL
 */
export const getLanguageFromUrl = (pathname) => {
    return (pathname === '/en/znajdz-punkt/') ? 'en' : 'pl';
};

/**
 * Oblicza poziom przybliżenia mapy (zoom) na podstawie dystansu i wybranych parametrów
 */
export const calculateZoomLevel = (distance, hasAddress, hasProvince, manualZoom = 0) => {
    if (manualZoom > 0) return manualZoom;

    let zoom;
    const dist = Number(distance);

    if (dist === 1) zoom = 15;
    else if (dist === 5) zoom = 12.75;
    else if (dist === 10) zoom = 11.75;
    else if (dist === 20) zoom = 10.75;
    else if (dist === 40) zoom = 9.75;
    else if (dist > 40) zoom = 8.75;
    else if (dist === 0) {
        if (hasAddress) zoom = 15;
        else {
            zoom = (Number(hasProvince) !== 0) ? 0 : 5.5;
        }
    }
    return zoom;
};

/**
 * Wyświetla komunikat o błędzie na mapie
 */
export const showMapError = (errorElement, message = "Brak wyników") => {
    if (!errorElement) return;
    errorElement.innerHTML = message;
    errorElement.classList.remove('d-none');
    errorElement.classList.add('d-block');
};

/**
 * Ukrywa komunikat o błędzie na mapie
 */
export const hideMapError = (errorElement) => {
    if (!errorElement) return;
    errorElement.innerHTML = null;
    errorElement.classList.add('d-none');
    errorElement.classList.remove('d-block');
};

/**
 * Podstawowa walidacja pola adresu
 */
export const validateAddressInput = (addressValue) => {
    return addressValue && addressValue.length >= 3;
};

/**
 * Zbiera dane z elementów formularza i dodaje je do obiektu FormData
 * @param {HTMLFormElement} form - Element formularza
 * @param {FormData} formData - Obiekt FormData do uzupełnienia
 */
export const populateFormData = (form, formData) => {
    if (!form || !formData) return;

    for (let i = 0; i < form.elements.length; i++) {
        let e = form.elements[i];
        let val;

        if ('checkbox' === e.type) {
            val = (true === e.checked) ? 1 : 0;
        } else if ('radio' === e.type) {
            val = (true === e.checked) ? e.value : undefined;
        } else {
            val = e.value;
        }

        if (typeof val !== 'undefined' && e.name) {
            formData.append(e.name, val);
        }
    }
};

/**
 * Wyświetla spinner ładowania
 */
export const getPreloaderHtml = () => {
    return '<div class="spinner-border text-primary mt-5" role="status"><span class="visually-hidden">Loading…</span></div>';
};

/**
 * Pobiera dane punktu i wyświetla tooltip (okno modalne)
 */
export const showPointTooltip = (id, lang, baseUrl, isCurrency = false) => {
    const para = document.createElement('div');
    const overlay = document.createElement('div');
    const body = document.createElement('div');
    const preloader = document.createElement('div');
    const rounding = document.createElement('div');

    para.classList.add('pp-map-tooltip');
    if (isCurrency) {
        para.classList.add('currency');
    }
    overlay.classList.add('pp-map-tooltip__overlay');
    body.classList.add('pp-map-tooltip__body', 'pp-map-tooltip__loading');
    rounding.classList.add('pp-map-tooltip__rounding');
    preloader.classList.add('pp-map-tooltip__preload');

    preloader.innerHTML = getPreloaderHtml();
    body.appendChild(preloader);
    overlay.appendChild(body);
    overlay.appendChild(rounding);
    para.appendChild(overlay);
    document.body.appendChild(para);
    document.body.style.overflow = "hidden";

    const closeTooltip = () => {
        para.remove();
        document.body.style.overflow = "";
        window.removeEventListener('keydown', handleEsc);
    };

    const handleEsc = (e) => {
        if (e.key === "Escape") closeTooltip();
    };

    window.addEventListener('keydown', handleEsc);

    const data = new FormData();
    data.append('pointid', id);
    data.append('lang', lang);
    if (isCurrency) data.append('currency', 1);

    fetch(`${baseUrl}/wp-content/plugins/pp-poiloader/point-info.php`, {
        method: 'POST',
        body: data
    })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
        })
        .then(html => {
            body.innerHTML = html;
            body.classList.remove('pp-map-tooltip__loading');
            const closeBtn = para.querySelector('.pp-map-tooltip__close');
            if (closeBtn) closeBtn.addEventListener('click', closeTooltip);
        })
        .catch(error => {
            console.error('Error fetching point info:', error);
            closeTooltip();
        });
};

/**
 * Konfiguruje niestandardowe renderowanie elementów dla jQuery UI Autocomplete
 * @param {jQuery} autocompleteElement - Element jQuery z zainicjowanym autocomplete
 */
export const setupAutocompleteRenderer = (autocompleteElement) => {
    if (!autocompleteElement || !autocompleteElement.data("ui-autocomplete")) return;

    autocompleteElement.data("ui-autocomplete")._renderItem = function (ul, item) {

        const term = this.term;
        const cleanTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp("(" + cleanTerm + ")", "gi");
        const highlightedLabel = item.label.replace(re, "<strong>$1</strong>");

        return jQuery("<li></li>")
            .data("item.autocomplete", item)
            .append("<a>" + highlightedLabel + "</a>")
            .appendTo(ul);
    };
};

/**
 * Niszczy instancję autocomplete dla podanego elementu DOM
 * @param {HTMLElement} element - Element z instancją autocomplete
 */
export const destroyAutocomplete = (element) => {
    if (element && element.classList.contains('ui-autocomplete-input')) {
        jQuery(element).autocomplete('destroy');
    }
};

/**
 * Przelicza poziom przybliżenia mapy (zoom) na dystans w metrach
 * @param {number} zoom - Poziom przybliżenia mapy
 * @returns {number} Dystans w metrach
 */
export const mapZoomToDistance = (zoom) => {
    if (zoom > 13) {
        return 2000;
    } else if (zoom > 12 && zoom <= 13) {
        return 7000;
    } else if (zoom > 11 && zoom <= 12) {
        return 14000;
    } else if (zoom > 10 && zoom <= 11) {
        return 25000;
    } else if (zoom <= 10) {
        return 50000;
    } else {
        return 70000;
    }
};

/**
 * Oblicza dystans w metrach między dwoma punktami geograficznymi (wzór Haversine)
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const toRadians = angle => angle * (Math.PI / 180);
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const earthRadius = 6371000; // Promień Ziemi w metrach

    return earthRadius * c;
};

/**
 * Sortuje listę punktów od najbliższego względem podanych współrzędnych centralnych
 * @param {Array} points - Lista punktów z właściwościami latitude i longitude
 * @param {Object} center - Obiekt ze współrzędnymi {lat, lng}
 * @returns {Array} Posortowana lista punktów z dodaną właściwością distance
 */
export const sortPointsByDistance = (points, center) => {
    if (!points || !center) return [];

    const result = points.map(point => {
        const distance = calculateDistance(center.lat, center.lng, point.latitude, point.longitude);
        return { ...point, 'distance': distance };
    });

    return result.sort((a, b) => a.distance - b.distance);
}

/**
 * Rysuje okrąg dystansu na mapie i usuwa go po 7 sekundach.
 * @param {Object} map - Instancja mapy Leaflet
 * @param {Object} center - Współrzędne środka {lat, lng}
 * @param {number} distance - Promień w kilometrach
 * @param {Object} existingCircle - Obecna grupa warstw (jeśli istnieje) do usunięcia
 * @param {number} existingTimeout - Obecny timeout (jeśli istnieje) do wyczyszczenia
 * @returns {Object} Obiekt zawierający nową grupę warstw i ID timeoutu
 */
export const drawDistanceCircle = (map, center, distance, existingCircle, existingTimeout) => {
    if (existingCircle) map.removeLayer(existingCircle);
    if (existingTimeout) clearTimeout(existingTimeout);

    const distanceCircleOnMap = L.featureGroup();

    L.circle([center.lat, center.lng], {
        fillColor: '#f03',
        fillOpacity: 0.07,
        radius: Number(distance) * 1000, // Przeliczenie km na metry
        weight: 0,
    }).addTo(distanceCircleOnMap);

    map.addLayer(distanceCircleOnMap);

    const distanceCircleTimeout = setTimeout(() => {
        map.removeLayer(distanceCircleOnMap);
    }, 7000);

    return {
        circle: distanceCircleOnMap,
        timeout: distanceCircleTimeout
    };
};

/**
 * Dodaje marker z popupem w określonych współrzędnych i usuwa poprzedni.
 * @param {Object} map - Instancja mapy Leaflet
 * @param {Array} coordinates - Tablica [lat, lng]
 * @param {Object} existingMarker - Obecny marker (jeśli istnieje) do usunięcia
 * @param {string} popupText - Treść wyświetlana w popupie
 * @returns {Object} Instancja nowo utworzonego markera
 */
export const addPopupForSelectedPoint = (map, coordinates, existingMarker, popupText = 'Wybrany punkt') => {
    // Usuwamy poprzedni marker jeśli istnieje
    if (existingMarker && typeof map.removeLayer === 'function') {
        map.removeLayer(existingMarker);
    }

    // Tworzymy nowy marker (z przezroczystością 0, aby pokazać tylko popup)
    const newMarker = L.marker(coordinates).addTo(map);
    newMarker.setOpacity(0);
    newMarker.bindPopup(popupText);
    newMarker.openPopup();

    return newMarker;
};

/**
 * Resetuje element select powiatów, czyści opcje i ustawia etykietę domyślną zależną od języka.
 * @param {HTMLElement} selectElement - Element <select> do zresetowania
 * @param {string} lang - Kod języka ('pl' lub 'en')
 * @param {string|null} item - Parametr kontrolny (jeśli nie null, dodaje opcję domyślną)
 */
export const ppmapDistrictSelectReset = (selectElement, lang, item = 'powiat') => {
    if (!selectElement) return;

    const provinceLabel = (lang === 'en') ? 'province' : 'powiat';
    selectElement.value = null;

    // Usuwanie wszystkich opcji
    while (selectElement.options.length > 0) {
        selectElement.remove(0);
    }

    // Dodawanie opcji domyślnej
    if (item !== null) {
        const myOption = document.createElement("option");
        myOption.text = provinceLabel;
        myOption.value = '0';
        selectElement.appendChild(myOption);
    }
};

/**
 * Pobiera szczegółowe dane o najbliższych punktach z serwera.
 * @param {Array} pointIds - Tablica ID punktów (pni)
 * @param {Object} center - Współrzędne środka {lat, lng}
 * @param {string} lang - Kod języka ('pl' lub 'en')
 * @param {string} baseUrl - Adres bazowy (window.location.origin)
 * @param {boolean} isCurrency - Czy blok walutowy
 * @returns {Promise<string>} HTML z listą punktów
 */
export const fetchNearestPointsHtml = (pointIds, center, lang, baseUrl, isCurrency = false) => {
    if (!pointIds || pointIds.length === 0) return Promise.resolve('');

    const url = `${baseUrl}/wp-content/plugins/pp-poiloader/nearest-points.php`;
    const data = new FormData();
    data.append('tab', pointIds.join(','));
    data.append('selected_point_lng', center.lng);
    data.append('selected_point_lat', center.lat);
    data.append('lang', lang);
    if (isCurrency) data.append('currency', 1);

    return fetch(url, {
        method: 'POST',
        body: data
    })
        .then(response => {
            if (!response.ok) throw new Error('Błąd pobierania punktów');
            return response.text();
        });
};

/**
 * Inicjalizuje mechanizm podpowiedzi (autocomplete) dla pola wyszukiwania.
 * @param {Object} options Obiekt z parametrami:
 *   - input: Element HTML pola wyszukiwania
 *   - baseUrl: window.location.origin
 *   - currentTab: aktualnie wybrana zakładka/filtr
 *   - extraParams: dodatkowe parametry wysyłane do search.php (np. ppmapBox_CurrencyExchange)
 *   - fetchAddressesFn: funkcja pobierająca adresy z API Poczty Polskiej
 *   - onSelect: callback wywoływany po wyborze elementu z listy
 */
export const initAutocomplete = ({
                                     input,
                                     baseUrl,
                                     currentTab,
                                     extraParams = {},
                                     fetchAddressesFn,
                                     onSelect
                                 }) => {
    const url = `${baseUrl}/wp-content/plugins/pp-poiloader/search.php?tab=${currentTab}`;

    jQuery(input).autocomplete({
        source: function (request, response) {
            request.tab = currentTab;

            Object.assign(request, extraParams);

            const ppPOIList = fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Accept': 'application/json, text/javascript, */*; q=0.01'
                },
                body: new URLSearchParams(request),
            })
                .then(res => res.ok ? res.json() : Promise.reject(res.status));

            const addressesList = fetchAddressesFn();

            Promise.all([ppPOIList, addressesList])
                .then(dataArray => {
                    let [ppPOIListResult, addressesListResult] = dataArray;
                    ppPOIListResult = ppPOIListResult?.length > 5 ? ppPOIListResult.slice(0, 5) : ppPOIListResult;
                    addressesListResult = addressesListResult?.slice(0, 10 - ppPOIListResult.length);

                    let combinedData = (ppPOIListResult.length === 1 && ppPOIListResult[0].label === "Brak danych")
                        ? [...addressesListResult]
                        : [...ppPOIListResult, ...addressesListResult];

                    response(combinedData);
                })
                .catch(error => console.error('Autocomplete fetch error:', error));
        },
        minLength: 2,
        select: function (event, ui) {
            const isAddress = !ui.item.hasOwnProperty('pid');
            const selectionData = {
                selected: {
                    lng: ui.item.longitude,
                    lat: ui.item.latitude,
                    val: ui.item.value
                }
            };
            onSelect(selectionData, isAddress);
        }
    });

    setupAutocompleteRenderer(jQuery(input));
};

/**
 * Przypisuje zdarzenia (kliknięcia) do elementów listy punktów.
 *
 * @param {HTMLElement} container - Kontener zawierający listę (np. this.mapPOILoaderResultTable)
 * @param {Object} mapInstance - Instancja mapy Leaflet
 * @param {Object} context - Kontekst klasy wywołującej (this), aby mieć dostęp do metod klasy
 * @param {Boolean} isCurrency - Czy wywołanie z bloku kantorów
 */
export const attachPointsListEvents = (container, mapInstance, context, isCurrency = false) => {
    const pointsBoxList = container.querySelectorAll('.points__box-wrapper');

    pointsBoxList.forEach((item) => {
        // 1. Kliknięcie w cały boks - centrowanie mapy i pomocniczy marker
        item.addEventListener('click', () => {
            const lat = parseFloat(item.getAttribute('data-lat'));
            const lng = parseFloat(item.getAttribute('data-lng'));
            const pointCoordinates = [lat, lng];

            // Wywołujemy dodanie popupa (metoda z helpera lub klasy)
            if (typeof context.addPopupForSelectedPoint === 'function') {
                context.addPopupForSelectedPoint(pointCoordinates);
            }

            // Centrowanie mapy
            const zoom = (typeof context.calculateMapZoom === 'function')
                ? context.calculateMapZoom()
                : mapInstance.getZoom();

            mapInstance.setView(pointCoordinates, zoom || 16);

            // Zaznaczenie elementu na liście (jeśli metoda istnieje)
            if (typeof context.markElementOnList === 'function') {
                context.markElementOnList(lat, lng);
            }
        });

        // 2. Kliknięcie w przycisk "Szczegóły" / "Kursy w placówce" - otwarcie tooltipa
        const buttonShowMore = item.querySelector('button.btn');
        if (buttonShowMore) {
            buttonShowMore.addEventListener('click', (e) => {
                e.stopPropagation(); // Zapobiega centrowaniu mapy przy kliknięciu w guzik
                const pni = buttonShowMore.getAttribute('data-pni');
                if (pni !== null) {
                    // Wywołujemy otwarcie tooltipa (metoda z klasy)
                    if (typeof context.openTooltip === 'function') {
                        context.openTooltip(pni);
                    } else if (typeof context.showPointTooltip === 'function') {
                        // Alternatywnie bezpośrednio z helpera jeśli klasa nie ma wrappera
                        context.showPointTooltip(pni, context.getLanguage(), context.urlPage.origin, isCurrency);
                    }
                }
            });
        }
    });
};